/**
 * Función que devuelve el dominio correspondiente al entorno.
 * Usa window.location.origin para funcionar en cualquier entorno (staging, producción, dev).
 */
export function getDomainUrl(): string {
	if (typeof window !== 'undefined' && window.location?.origin) {
		return window.location.origin;
	}
	return process.env.REACT_APP_APP_URL || 'http://localhost:3000';
}

export function getPayfitRedirectUri(): string {
	if (typeof window !== 'undefined' && window.location?.origin) {
		return window.location.origin;
	}
	return process.env.REACT_APP_APP_URL || 'http://localhost:3000';
}
